import Hits from './hits';

export default Hits;
